
import { MapTo } from '@adobe/aem-react-editable-components';
import MitekTest, { MitekTestEditConfig } from './MitekTest';

export default MapTo('cob-corp-acquisition/components/creditonebank/mitek-test')(MitekTest, MitekTestEditConfig);
        